import React from 'react';
import { HeaderBlock } from './Header.styles';

export default function Header({ ...props }) {
    return <HeaderBlock {...props} />;
}

Header.splash = {
    ...HeaderBlock.splash,
    defaultProps: {
        ...HeaderBlock.splash.defaultProps,
        styles: {
            ...HeaderBlock.splash.defaultProps.styles,
            backgroundColor: '',
        },
    },
};
